// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__2OQvc","errContainer":"NotFound_errContainer__sfwSd","error":"NotFound_error__tczps","errMsg":"NotFound_errMsg__lOEo0"};